import TextArea from 'common/components/TextArea';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    other: string;
}

interface Props<T> {
    form: ObservableForm<T>;
}

const OtherField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
}) => {
    return (
        <Field
            form={form}
            name="other"
            title={__("Anything else you'd like to share with your designer?")}
            render={() => <TextArea {...form.attach('other')} fill={true} />}
        />
    );
};

export default OtherField;
